import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { SelectSimple } from '@mssgme/ui';

export function SelectMessengerType({ platform, ...props }) {
    const { t } = useTranslation('cards');
    let messengerTypes = [];

    if (platform === 'whatsapp') {
        messengerTypes.push(
            {
                label: t('selectMessengerType.phone'),
                value: 'private',
            },
            {
                label: t('selectMessengerType.chat'),
                value: 'public',
            }
        );
    }

    if (platform === 'viber') {
        messengerTypes.push(
            {
                label: t('selectMessengerType.phone'),
                value: 'private',
            },
            {
                label: t('selectMessengerType.public'),
                value: 'public',
            },
            {
                label: t('selectMessengerType.community'),
                value: 'community',
            }
        );
    }

    return <SelectSimple {...props} options={messengerTypes} />;
}

SelectMessengerType.propTypes = {
    platform: PropTypes.string.isRequired,
};
